<template>
  <div>
    <right-panel :datas="connects" :items="connects" @onClose="onCloseForm" @onSubmit="onSubmitForm" ref="right-panel">
      <div slot="header">
        <translate>Change ClusterName</translate>
      </div>
    </right-panel>
  </div>
</template>

<script>
  import STORE_CONST from '../../../store/consts'
  import RightPanel from '../../common/right-panel'
  export default{
    name: 'ChangeClusterName',
    props: {
      items: {
        required: true
      }
    },
    data () {
      return {
        connects: null
      }
    },
    methods: {
      // 确定创建集群
      onSubmitForm () {
        console.log('id----', this.$route.params)
        let params = {
          id: this.$route.params.id,
          data: Object.assign({}, this.$refs['right-panel'].profileModel)
        }
        this.$store.dispatch(STORE_CONST.CLUSTER.CHANGE, params).then(() => {
          this.$notify({
            type: 'success',
            message: this.$gettext('Change successfully!')
          })
          this.$emit('callback')
          this.$refs['right-panel'].onClose()
        }).catch(err => {
          console.log('err', err)
          this.$refs['right-panel'].onSubmitErr()
        })
      },
      // 关闭创建集群
      onCloseForm () {
        this.connects = null
        this.$emit('onClosePanel')
      }
    },
    watch: {
      'items': {
        handler: function (newVal) {
          if (this.connects) {
            this.connects = null
            setTimeout(() => {
              this.connects = this.items
            }, 300)
          } else {
            this.connects = this.items
          }
        },
        deep: true
      }
    },
    components: {
      RightPanel
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">

</style>



// WEBPACK FOOTER //
// cluster-change-name.vue?7d556cf8